import axios from "axios";
import router from "@/router";
import { ElMessage } from "element-plus";
import { useInstitutionStore } from '@/store/institutionStore';
import { shouldAttachHospitalScope } from "@/utils/institutionAccess";

const instance = axios.create({
  baseURL: "/api/v1",
  timeout: 3600000, // 一小时
  //Authorization
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    // 有授权医院时增加医院编码
    const selectorStore = useInstitutionStore();
    if (
      selectorStore.hasHospitalAccess &&
      shouldAttachHospitalScope(config.url, selectorStore.options, selectorStore.selectedId)
    ) {
      if (typeof config.headers?.set === "function") {
        config.headers.set("X-Hospital-Code", selectorStore.selectedId);
      } else {
        config.headers = config.headers || {};
        config.headers["X-Hospital-Code"] = selectorStore.selectedId;
      }
    }
    // const token = sessionStorage.getItem("token");
    // 从 localStorage 中获取 token
    const token = localStorage.getItem("token");
    const ttl = localStorage.getItem("ttl");
    //now 当前时间时间戳
    const now = new Date().getTime();
    // 如果 token 过期了, 清除 token, 并重定向到登录页
    if (Number(ttl) < now) {
      localStorage.removeItem("token");
      localStorage.removeItem("ttl");
      localStorage.removeItem("userInfo");
      router.push("/");
    } else {
      if (token) {
        config.headers.Authorization = token; // 设置 Authorization 头
        // 设置本地的cookie
        document.cookie = `token=${token}; path=/`;
        // 设置响应超时时间为1小时
        config.timeout = config.timeout ?? 3600000;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    if (response.headers["content-type"] !== "application/json") {
      return response;
    } else {
      return response.data;
    }
  },
  async (error) => {
    // Switching filters or leaving a page intentionally cancels in-flight requests.
    if (error?.code === "ERR_CANCELED") return Promise.reject(error);
    // 下载接口使用 blob，错误响应仍可能是后端的 JSON 鉴权结果。
    let errorData = error.response?.data;
    if (errorData instanceof Blob) {
      try {
        errorData = JSON.parse(await errorData.text());
      } catch {
        errorData = undefined;
      }
    }
    //限制最多只弹出5个错误
    ElMessage({
      message: errorData?.message || error.message || "请求失败",
      type: "error",
      grouping: true,
    });
    console.log("error", error);
    // 权限不足不等于登录失效；保留会话，让用户继续使用已授权功能。
    const status = error.response?.status;
    const permissionDenied = status === 403 && errorData?.code === 40203;
    if (status === 401 || (status === 403 && !permissionDenied)) {
      // 重定向到登录页, 清除 token
      // sessionStorage.removeItem("token");
      localStorage.removeItem("token");
      localStorage.removeItem("ttl");
      localStorage.removeItem("userInfo");
      router.push("/");
    }
    return Promise.reject(error);
  }
);

export default instance;
